import React from 'react';

import type { EventsVariants } from 'Theme/types/components.type';

import { ArrowLinkProps } from 'Elements/Link/Arrow';

import {
    Container,
    Heading,
    Text,
    EventItem,
    EventTitle,
    EventDate,
    StyledLink
} from './Upcoming.styled';

export interface Props {
    id?: string;
    heading: string;
    text?: string;
    events: {
        id: string;
        title: string;
        date: Date;
        link: ArrowLinkProps;
        variant?: EventsVariants;
    }[];
    noEvents: {
        content: React.ReactNode;
        bookLink?: ArrowLinkProps;
    };
    dateOptions?: Intl.DateTimeFormatOptions;
}

const Upcoming: React.FC<Props> = props => {
    const {
        id,
        heading,
        text,
        events,
        noEvents,
        dateOptions = { day: 'numeric', month: 'long', year: 'numeric' }
    } = props;

    return (
        <Container id={id}>
            <Heading>{heading}</Heading>
            {text && <Text>{text}</Text>}
            {events.length !== 0 ? (
                events.map(event => (
                    <EventItem key={event.id} $variant={event.variant || 'default'}>
                        <EventTitle>
                            {event.title}
                            <EventDate>
                                {event.date.toLocaleString('en-GB', dateOptions).replace(',', '')}
                            </EventDate>
                        </EventTitle>
                        <StyledLink {...event.link} />
                    </EventItem>
                ))
            ) : (
                <>
                    {noEvents.content}
                    {noEvents.bookLink && <StyledLink {...noEvents.bookLink} />}
                </>
            )}
        </Container>
    );
};

export default Upcoming;
